var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.spin)?_c('div',[_c('div',{staticClass:"loading",class:[_vm.showBackground ? 'transparent': 'bg']},[_vm._m(0)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div')])
}]

export { render, staticRenderFns }